@if (imageLoaded) {
<canvas
    class="pdf-canvas"
    #canvasElement
    [width]="width"
    [height]="height"
></canvas>
<img
    #imgElement
    class="image-overlay"
    [width]="width"
    [height]="height"
    [style]="{
        objectFit: 'cover',
        objectPosition: side === sideEnum.Left ? 'left' : 'right'
    }"
/>
}
